import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Micro, Spark } from "@/components/layernav/primitives";
import { SECTORS, SECTOR_LABELS } from "@/components/layernav/navConfig";
import { homeTrack } from "./shared";

export const TrendingSectorRail = () => {
  const { data } = useQuery({
    queryKey: ["sectors-activity"],
    queryFn: async () => (await api.get("/sectors/activity")).data,
    staleTime: 5 * 60 * 1000,
  });
  const top = data?.top;
  if (!top || !top.count) return null;
  const label = SECTOR_LABELS[top.slug] || top.slug;
  const route = SECTORS.find((s) => s.slug === top.slug)?.to || `/${top.slug}`;
  const daily: number[] = (data.top_daily || []).map((d: any) => d.count);
  const share = data.top_share_pct;

  return (
    <section data-testid="trending-sector-rail"
      className="bg-[#000000] border border-white/[0.08] rounded-xl mt-4 px-5 sm:px-7 py-4 flex items-center gap-x-5 sm:gap-x-8 gap-y-2 flex-wrap">
      <Micro cyan>Trending Sector</Micro>
      <span className="font-heading font-black text-white text-lg sm:text-xl tracking-tight">
        {label} <span aria-hidden className="text-[#22C55E]">↑</span>
      </span>
      <span className="font-mono text-[11px] text-gray-500" data-testid="trending-sector-stats">
        {top.count} {top.count === 1 ? "story" : "stories"}
        {share != null ? ` · ${share}% of 24h coverage` : ""}
      </span>
      {daily.length > 1 && (
        <>
          <Spark points={daily} up className="w-20 h-6 hidden sm:block" />
          <span className="sr-only">7 day publishing trend for {label}</span>
        </>
      )}
      <Link to={route} data-testid="trending-sector-cta" onClick={() => homeTrack("trending_sector", route)}
        className="group ml-auto inline-flex items-center gap-1.5 text-[13px] font-bold text-[#00E5FF] hover:text-white transition-colors">
        Explore {label}
        <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-1" />
      </Link>
    </section>
  );
};
